import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import Comment from './Comment'

export default function CommentsList({ comments }) {
  const sortedComments = comments.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at)
  })

  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100%'
      maxHeight='calc(100vh - 480px)'
      minHeight='30px'
      color='colorTextMain'
      marginBottom='spaceGapMedium'
      overflowY='auto'
    >
      { sortedComments.map((comment, index) => <Comment key={index} comment={comment} />)}
    </Box>
  )
}

CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
}
